import { CSSProperties, forwardRef, memo, useCallback, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryResultItemInfo.module.scss";
import { PupilResult } from "shared/types/sociometry";
import { SociometryResultDetailsQuestions } from "../SociometryResultDetailsQuestions/SociometryResultDetailsQuestions";
import { HStack, VStack } from "components/landingNew/shared/ui/Stack";
import { SociometryMutualPairsList } from "../SociometryMutualPairsList/SociometryMutualPairsList";
import { Button } from "shared/ui/Button";
import { SociometryAnnulResultModal } from "../SociometryAnnulResultModal/SociometryAnnulResultModal";

interface SociometryResultItemInfoProps {
    className?: string;
    style: CSSProperties;
    score: PupilResult;
    sessionId: string;
    onAnnulled?: () => void;
}

export const SociometryResultItemInfo = forwardRef<HTMLDivElement, SociometryResultItemInfoProps>((props, ref) => {
    const { className, style, score, sessionId, onAnnulled } = props;
    const [isAnnulOpen, setIsAnnulOpen] = useState(false);
    const pupilId = score.pupil?._id || "";

    const openAnnulModal = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setIsAnnulOpen(true);
    }, []);

    const closeAnnulModal = useCallback(() => {
        setIsAnnulOpen(false);
    }, []);

    return (
        <div ref={ref} style={style} className={classNames(cls.sociometryResultItemInfo, {}, [className])}>
            <VStack gap={12}>
                <HStack justify="between" gap={12} max>
                    <p className={cls.title}>Результаты тестирования</p>
                    <Button variant="primary" color="red" size="small" onClick={openAnnulModal} disabled={!pupilId}>
                        Аннулировать результат
                    </Button>
                </HStack>
                <SociometryAnnulResultModal
                    isOpen={isAnnulOpen}
                    onClose={closeAnnulModal}
                    sessionId={sessionId}
                    pupilId={pupilId}
                    onAnnulled={onAnnulled}
                />
                <SociometryResultDetailsQuestions answers={score?.answers || []} />
            </VStack>
            <VStack gap={12}>
                <p className={cls.title}>Взаимные пары ученика</p>
                <SociometryMutualPairsList pairs={score?.mutualPairs || []} showTitle={false} variant="light" gap={8} />
            </VStack>
        </div>
    );
});

SociometryResultItemInfo.displayName = "SociometryResultItemInfo";
